import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import * as React from "react";
import { useLanguage } from "../../Language";
import { useDisplayMapItButton, useStackMap } from "../../Stackmap";
import { StackMapButton } from "./StackMapButton";
import { useGlobalConfig } from "../../GlobalConfig";
import {
  HoldingsInformation,
  ResourceDWR,
} from "../../../dto/SuggestionResult";
import { useItemAvailability } from "./ItemAvailability";
export interface NonSerialHoldingsProps {
  holdings: HoldingsInformation[];
  resource: ResourceDWR;
}
export const NonSerialHoldings: React.FC<NonSerialHoldingsProps> = ({
  holdings,
  resource,
}) => {
  const { translate } = useLanguage();
  const { openMapItDialog, stackMapEnabled } = useStackMap();
  const { globalSettings } = useGlobalConfig();
  const { itemAvailability, ready: itemAvailabilityReady } =
    useItemAvailability(holdings, resource);
  const displayMapItButton = useDisplayMapItButton(
    holdings,
    itemAvailability,
    itemAvailabilityReady,
    resource
  );

  const showDueDateForItems = globalSettings?.showDueDateForItems; // TODO pre-fetch globalSettings

  const getVolumeAndCopyFromHolding = function (holding: HoldingsInformation) {
    if (!holding) {
      return "";
    }

    let holdingWithVolumeAndCopy =
      (holding.volume ? holding.volume + " " : "") +
      (holding.copy ? holding.copy + " " : "") +
      (holding.year ? holding.year : "");

    return holdingWithVolumeAndCopy.trim();
  };

  const getPartsInfo = (holding: HoldingsInformation) => {
    if (!holding || !holding.parts) return "";
    return holding.parts;
  };

  return (
    <>
      <Table component="table">
        <TableHead component="thead">
          <TableRow component="tr">
            <TableCell component="th">{translate("collection")}</TableCell>
            <TableCell component="th">{translate("shelfLocation")}</TableCell>
            <TableCell component="th">{translate("status")}</TableCell>
            <TableCell component="th">
              {stackMapEnabled ? translate("stackMapColumnHeader") : ""}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody component="tbody">
          {holdings.map((holding) => {
            const availability = itemAvailability.get(holding.barcode);
            return (
              <TableRow component="tr" key={holding.id}>
                <TableCell component="td" scope="row">
                  {holding.collectionName}
                </TableCell>
                <TableCell component="td">
                  {holding.shelfLocation} {getVolumeAndCopyFromHolding(holding)}{" "}
                  {getPartsInfo(holding)}
                </TableCell>
                <TableCell component="td">
                  <span
                    className={
                      availability?.status && availability?.available
                        ? "available"
                        : ""
                    }
                  >
                    {availability?.status}{" "}
                  </span>
                  <br />
                  {showDueDateForItems && availability?.dueDate ? (
                    <strong>
                      {translate("dueBack")} {availability?.dueDateString}
                    </strong>
                  ) : (
                    ""
                  )}
                </TableCell>
                <TableCell component="td">
                  {displayMapItButton.get(holding.id) ? (
                    <StackMapButton
                      onClick={() => openMapItDialog(holding.id)}
                    />
                  ) : (
                    <span>&nbsp;</span>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </>
  );
};
